import React from 'react'
import PropTypes from 'prop-types'
import { FaChevronDown } from 'react-icons/fa'

import { TypeLink } from '../../../utils/types'
import nofollow from '../../../utils/helpers/nofollow'

import {
  PortraitListItem as Wrapper,
  PortraitLink,
  PortraitNavSubList,
  PortraitSubLink,
  LineItem,
  DropDownIcon,
} from './styled'

export const PortraitListItem = ({
  links = [],
  title,
  url,
  isOpen,
  onDropDownAction,
}) => {
  const isAccordionOpen = links.length > 0 && isOpen

  return (
    <Wrapper>
      <LineItem onClick={onDropDownAction}>
        <PortraitLink href={url}>{title}</PortraitLink>
        {links.length > 0 && (
          <DropDownIcon isOpen={isOpen}>
            <FaChevronDown />
          </DropDownIcon>
        )}
      </LineItem>

      {isAccordionOpen && (
        <PortraitNavSubList isOpen={isAccordionOpen}>
          {links.map(subLink => (
            <PortraitSubLink
              key={subLink.title}
              href={subLink.url}
              target={subLink.target}
              rel={nofollow(subLink.target)}
            >
              {subLink.title}
            </PortraitSubLink>
          ))}
        </PortraitNavSubList>
      )}
    </Wrapper>
  )
}

PortraitListItem.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  links: PropTypes.arrayOf(TypeLink),
  isOpen: PropTypes.bool,
  onDropDownAction: PropTypes.func,
}

export default PortraitListItem



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Navigation/PortraitListItem.js